// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2NUaR","title":"InfoRow_title__30TWe"};